<div class="w-full px-4 py-6">
    <div class="flex flex-wrap -mx-2 text-center">
        <div class="centered-box">
            <div class="flex flex-wrap -mx-2">
                <div class="w-full sm:ml-[8.333333%] sm:flex-none sm:w-5/6 px-2">
                    <figure class="my-2">
                        <img src="../../assets/images/cbicon.svg" class="cb-icon" alt="SalesIntel">
                    </figure>
                    <h3 class="my-4">
                        Contact sales to upgrade.<br />
                    </h3>
                    <p>Fill the contact form on our website to schedule an extensive demo and to get advice on which
                        enterprise plan will fit your needs best or to discuss any specific functionality.</p>
                    <p> Please reach us at <a title="support@salesintel.io" target="_blank"
                            href="mailto:support@salesintel.io">support&#64;salesintel.io</a>
                        if we can help you in any other way. Happy Prospecting!
                    </p>
                    <div class="my-2">
                        <a matButton="filled" target="_blank" title="Schedule Demo" href="https://salesintel.io/request-a-demo/"
                            class="px-6">
                            Schedule Demo
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
